import $ from 'jquery'
import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import { withRouter } from "react-router-dom";
import templateData, { localsMessages, isMobileHeaderExp } from '../../utility/getTemplateData'
import { hideSpinnerOverlay } from '../../utility/helper';
import { hideLanguageSelector } from '../../utility/languageSelector';
import { Button } from '@paypalcorp/pp-react';
import Illustration from '../../components/illustrations/Illustration';
import ConfirmationTitle from '../../confirmation/ConfirmationTitle';
import ConfirmationBody from '../../confirmation/ConfirmationBody';

class ThreeDSError extends React.Component {
	
	componentDidMount = () => {
		hideSpinnerOverlay();
		hideLanguageSelector();
	}

	handleTryAgain = () => {
        this.props.history.push(`/donate?token=${templateData.token}`)
	}

	render() {

        const error = localsMessages('errors/threeDSError');

        return (
        	<div>
        		<div className={`donate_wrapper confirmation ${isMobileHeaderExp() ? 'mobile_view' : ''}`}>
        			<div className="ppvx_row">
        				<div className="ppvx_col-12 ppvx_d-flex ppvx_justify-content-center">
        					<Illustration type="warning" />
        				</div>
        			</div>
        			<div className="ppvx_row">
        				<div className="ppvx_col-12 text-center">
							<ConfirmationTitle message={error.errorMessage} />
        				</div>
        			</div>
        			<div className="ppvx_row">
        				<div className="ppvx_col-12 text-center">
							<ConfirmationBody message={error.tryAgain} />
        				</div>
        			</div>

        			<div className="ppvx_row">
        				<div className="ppvx_col-12 text-center">
							<Button
								className="btn-wide"
								id="tryAgain"
								onClick={this.handleTryAgain}
							>{error.tryCard}
							</Button>
        				</div>
        			</div>
        		</div>
        	</div>
        )
    }
}

export default withRouter(ThreeDSError);
